import * as $ from "jquery";
import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Filter } from "../../models/filter.model";
import { Team } from "../../models/team.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { SearchUtils } from "../../helper/search.helper";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { Division } from "../../models/division.model";

let UserFilterPane = {
    selector: "vcUserFilterPane",
    templateUrl: "/angular/components/filter/user-filter-pane.html",
    bindings: {
        items: "=?",
    },
    controller: class UserFilterPaneController {
        // * bindings for typescript compiler *
        public items?: any;
        // ************************************

        public readonly defaultFilter = new Filter({
            permission: { values: [], checked: false },
            teams: { values: [], checked: false },
            divisions: { values: [], checked: false },
            search: { values: "", checked: true },
        });

        public filter: Filter;
        public appliedFilter: Filter;
        public emptyFilter: Filter;
        public selectedFilter: Filter;
        public selectedUsers: User[] = [];
        public firstLoad = true;
        public activeCampaign: Campaign;
        public isOrganisationCampaign: boolean;
        public teams: Team[];
        public divisions: Division[] = [];

        private readonly $scope: any;
        private readonly $location: any;

        private readonly navigationBarService: NavigationBarHelperService;
        private readonly searchUtils: SearchUtils;

        public readonly dataProvider: FilterDataProvider;
        public readonly permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $location: any,
            FilterDataProvider: FilterDataProvider,
            TeamDataProvider: TeamDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            SearchUtils: SearchUtils,
            DivisionDataProvider: DivisionDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.dataProvider = FilterDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;
            this.searchUtils = SearchUtils;

            this.filter = FilterDataProvider.filter;
            this.appliedFilter = FilterDataProvider.appliedFilter;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isOrganisationCampaign =
                this.activeCampaign.isOrganisationCampaign();

            _.merge(this.filter, _.cloneDeep(this.defaultFilter));
            this.setFilters(this.defaultFilter);

            TeamDataProvider.getAllTeams().then((teams: Team[]) => {
                this.teams = teams;
            });

            if (__app_type === "LEADER") {
                DivisionDataProvider.getAllDivisions().then(
                    (divisions: Division[]) => {
                        this.divisions = divisions.filter(
                            (division: Division) => division.id != null
                        );
                    },
                    (error: any) => {
                        this.divisions = [];
                    }
                );
            }

            this.$scope.$watch(
                () => this.appliedFilter,
                () => {
                    this.dataProvider.nonEmptyAppliedFilters(this.firstLoad);
                    this.searchUtils.searchText = this.appliedFilter.search
                        ? this.appliedFilter.search.values
                        : "";
                    this.$location.search(
                        "filter",
                        JSON.stringify(this.filter.nonEmptyValues())
                    );
                },
                true
            );
        }

        closeFilterBar(): void {
            this.navigationBarService.setFilterBarOpen(false);
        }

        previousFilter(filter?: Filter): Filter {
            let search = angular.isDefined(filter)
                ? { filter: filter }
                : this.$location.search();
            return this.dataProvider.reformatFilter(search);
        }

        setFilters(filters: Filter): void {
            this.emptyFilter = _.cloneDeep(filters);
            this.filter.setData(_.merge(filters, this.previousFilter()));
            _.merge(this.appliedFilter, _.cloneDeep(this.filter));
            this.$location.search(
                "filter",
                JSON.stringify(this.filter.nonEmptyValues())
            );
        }

        applyFilters(): void {
            $("#mainDataContainer").scrollTop(0);
            const currentSearch = _.cloneDeep(this.appliedFilter.search);
            this.dataProvider.removeValues(this.appliedFilter);
            _.merge(this.appliedFilter, _.cloneDeep(this.filter));
            if (currentSearch && currentSearch.values) {
                this.appliedFilter.search = currentSearch;
            }
        }

        clearFilters(): void {
            this.selectedFilter = null;
            const search = this.filter.search;
            this.filter = _.cloneDeep(this.emptyFilter);
            this.filter.search = search;
            this.applyFilters();
        }

        filterChanged(): boolean {
            return !angular.equals(
                this.filter.nonEmptyValues(),
                this.appliedFilter.nonEmptyValues()
            );
        }
    },
};

angular.module("filter").component(UserFilterPane.selector, UserFilterPane);
